import { OVERLAY_VIEWPORT_Z_INDEX_CLASS } from "../../utils/constants.js";
import { tv } from "../../variants/tv.js";
const dialogVariants = tv({
    slots: {
        popup: `fixed top-1/2 left-1/2 flex max-h-[calc(100dvh-64px)] -translate-x-1/2 -translate-y-1/2 flex-col rounded-2xl bg-primary-1 shadow-overlay-lg brightness-100 transition-[filter,scale,opacity] duration-400 outline-none [--popup-corner-b:var(--radius-2xl,1rem)] [--popup-corner-t:var(--radius-2xl,1rem)] [-webkit-backface-visibility:hidden] [backface-visibility:hidden] data-[ending-style]:scale-95 data-[ending-style]:opacity-0 data-[nested-dialog-open]:scale-90 data-[nested-dialog-open]:brightness-60 data-[nested-drawer-open]:scale-90 data-[nested-popover-open]:scale-90 data-[starting-style]:scale-95 data-[starting-style]:opacity-0 ${OVERLAY_VIEWPORT_Z_INDEX_CLASS}`,
        drawerPopup: 'flex max-h-[calc(100dvh-16px)] w-full max-w-[100vw] [transform:translateY(var(--drawer-swipe-movement-y))] flex-col rounded-t-2xl bg-primary-1 pb-[env(safe-area-inset-bottom)] shadow-overlay-lg brightness-100 transition-[filter,transform,scale,opacity] duration-[450ms] ease-[cubic-bezier(0.32,0.72,0,1)] outline-none [--popup-corner-b:0] [--popup-corner-t:var(--radius-2xl,1rem)] [-webkit-backface-visibility:hidden] [backface-visibility:hidden] data-[ending-style]:[transform:translateY(calc(100%+2px))] data-[ending-style]:opacity-0 data-[ending-style]:duration-[calc(var(--drawer-swipe-strength)*400ms)] data-[nested-dialog-open]:scale-90 data-[nested-dialog-open]:shadow-none data-[nested-dialog-open]:brightness-60 data-[nested-drawer-open]:scale-90 data-[nested-drawer-open]:shadow-none data-[nested-popover-open]:scale-90 data-[nested-popover-open]:shadow-none data-[starting-style]:[transform:translateY(calc(100%+2px))] data-[starting-style]:opacity-0 data-[swiping]:duration-0',
        viewport: [
            'fixed inset-0 isolate flex items-end justify-center',
            OVERLAY_VIEWPORT_Z_INDEX_CLASS
        ],
        backdrop: [
            'fixed inset-0 min-h-dvh bg-neutral-13/50 transition-opacity duration-150 data-[ending-style]:opacity-0 data-[starting-style]:opacity-0',
            OVERLAY_VIEWPORT_Z_INDEX_CLASS
        ],
        title: '',
        description: 'text-body1 text-neutral-10',
        close: ''
    },
    variants: {
        size: {
            sm: {
                popup: 'w-full max-w-[min(30rem,calc(100dvw-16px))]'
            },
            md: {
                popup: 'w-full max-w-[min(45rem,calc(100dvw-16px))]'
            },
            lg: {
                popup: 'w-full max-w-[min(60rem,calc(100dvw-16px))]'
            },
            full: {
                popup: 'h-[calc(100dvh-16px)] max-h-[calc(100dvh-16px)] w-[calc(100dvw-16px)] max-w-[calc(100dvw-16px)]',
                drawerPopup: 'h-dvh max-h-dvh rounded-t-none'
            }
        }
    },
    defaultVariants: {
        size: 'sm'
    }
});
const dialogSizes = Object.keys(dialogVariants.variants.size);
export { dialogSizes, dialogVariants };
